import React from 'react'
import styled from 'styled-components'

import ItemLine from './ItemLine'
import TextBox from './TextBox'

/**
 * 対象がTextAreaLineProps型かチェックする
 * @param target チェック対象
 */
export const isTextAreaLineProps = (
  target: any
): target is TextAreaLineProps => {
  return target.inputText !== undefined
}

/**
 * 高さが可変のテキストエリア行
 */
const TextAreaLine: React.FC<TextAreaLineProps> = (props) => {
  const handleSetShowAlert = (isInvalid: boolean): void => {
    if (isInvalid === undefined || !props.setShowAlert) return
    props.setShowAlert(isInvalid)
  }
  return (
    <ItemLine
      input={props.inputText}
      variableHeight
      paddingUnnecessary
      width={props.width}
      isInvalid={props.isInvalid}
      setShowAlert={handleSetShowAlert}
    >
      <TextAreaItemLine>
        <TextBox
          inputText={props.inputText}
          onChange={props.onChange}
          placeholder={props.placeholder}
          maxLength={props.maxLength}
        />
      </TextAreaItemLine>
    </ItemLine>
  )
}

export type TextAreaLineProps = {
  regex?: string
  width?: string
  inputText: string
  placeholder?: string
  maxLength?: number
  hasError?: boolean
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  isInvalid?: boolean
  setShowAlert?: (value: boolean) => void
}

export const TextAreaItemLine = styled.div`
  position: relative;
  flex: 1;
`

export default TextAreaLine
